import { NotificationType } from '../enums/notification-type.enum'

export class NotificationModel {
  id: number
  message: string
  type: NotificationType

  constructor(message: string, type: NotificationType) {
    this.id = Math.random() * (1000000 - 1000) + 1000
    this.message = message
    this.type = type
  }
}
